
import React from 'react';
import { Play, Pause, Loader2, VolumeX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TextToSpeechProps } from '@/services/speech/TextToSpeechService';
import { useTextToSpeech } from '@/hooks/speech/useTextToSpeech';

const TextToSpeech = (props: TextToSpeechProps) => {
  const { 
    isPlaying, 
    isGenerating, 
    configError, 
    handlePlay, 
    handlePause 
  } = useTextToSpeech(props);

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        onClick={isGenerating ? undefined : handlePlay}
        disabled={isGenerating || isPlaying}
        className="w-5 h-5 p-0"
        aria-label={configError ? configError : "Play audio"}
      >
        {isGenerating ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : configError ? (
          <VolumeX className="h-4 w-4 text-red-500" />
        ) : (
          <Play className="h-4 w-4" />
        )}
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        onClick={handlePause}
        disabled={isGenerating || !isPlaying}
        className="w-5 h-5 p-0"
        aria-label="Pause audio"
      >
        <Pause className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default TextToSpeech;
